module.exports = __webpack_public_path__ + "img/group-gray.da5a2642.svg";